import React from 'react';
import Widget from 'components/Widget/Widget';
import PropTypes from 'prop-types';
import Icon from '@mdi/react';
import { mdiFinance } from '@mdi/js';
import TotalPnL from './TotalPnL';
import { Button } from 'antd';

const TotalProfitsAndLosses = ({ height, data, index, configuration }) => {
  return (
    <Widget
      title={data.title}
      icon={<Icon path={mdiFinance} className='text-orange' />}
      widget_key={'totalPnL_widget' + index}
      configuration={configuration}
      disableLimit
      disableStatusFilter
      disableLevelFilter
      networkSwitch={false}
      default_filter={data?.defaultFilter}
      index={index}
      adsFilter
      adsetFilter
      campaignFilter
      showDatePicker
      showNetworkSwitcher
      position={data?.position}
      dashboard_widget_key={data?.key}
    >
      <TotalPnL height={height} data={data} index={index} />
    </Widget>
  );
};

export default TotalProfitsAndLosses;

TotalProfitsAndLosses.propTypes = {
  height: PropTypes.number.isRequired,
  data: PropTypes.object.isRequired,
  index: PropTypes.number.isRequired,
};
